import { createJsonQuery, declareParams, unknownContract } from '@farfetched/core'
import { window } from '@mtsdengi/ui-kit'
import { headerTemplateSso } from '@api/utils'

export const sendSmsCodeQuery = createJsonQuery({
  params: declareParams<{
    phone: string
    clientId: string
  }>(),
  request: {
    method: 'POST',
    url: () => `${window.location.origin}/auth/sms/send-code/`,
    headers: () => ({ ...headerTemplateSso }),
    body: ({ phone }) => ({ phone }),
  },
  response: {
    contract: unknownContract,
    mapData: ({ result }) => result,
  },
})

export const checkSmsCodeQuery = createJsonQuery({
  params: declareParams<{
    phone: string
    code: string
    clientId: string
  }>(),
  request: {
    method: 'POST',
    url: () => `${window.location.origin}/auth/sms/check/`,
    headers: () => ({ ...headerTemplateSso }),
    body: ({ phone, code }) => ({ phone, code }),
  },
  response: {
    contract: unknownContract,
    mapData: ({ result }) => result,
  },
})
